import { createContext } from "react";
import type { TPost } from "@/utils/validators";
import { getBookmarkedPosts } from "@/utils/localstorage";
import { useState } from "react";

type BookmarksContextType = {
  bookmarkedPosts: TPost[];
  addBookmark: (post: TPost) => void;
  removeBookmark: (postId: number) => void;
};

export const BookmarksContext = createContext<BookmarksContextType | null>(
  null,
);

export function BookmarksProvider({ children }: { children: React.ReactNode }) {
  const [bookmarkedPosts, setBookmarkedPosts] = useState<TPost[]>(() => {
    return getBookmarkedPosts();
  });

  function addBookmark(post: TPost) {
    const updatedBookmarks = [...bookmarkedPosts, post];
    setBookmarkedPosts(updatedBookmarks);
    localStorage.setItem("bookmarks", JSON.stringify(updatedBookmarks));
  }

  function removeBookmark(postId: number) {
    const updatedBookmarks = bookmarkedPosts.filter(
      (post) => post.id !== postId,
    );
    setBookmarkedPosts(updatedBookmarks);
    localStorage.setItem("bookmarks", JSON.stringify(updatedBookmarks));
  }

  return (
    <BookmarksContext.Provider
      value={{ bookmarkedPosts, addBookmark, removeBookmark }}
    >
      {children}
    </BookmarksContext.Provider>
  );
}
